import axios, { type AxiosError } from 'axios';
import mixpanel from 'mixpanel-browser';

import { CTAInteractionTrackingEvents } from '@revelio/core';

import { environment } from '../../environment';
import type { FormValues } from '../components/models';

const isProduction = window.location.host.startsWith('account.reveliolabs.com');

export const createVerifiedUserA = async ({
  body,
  csrfToken,
}: {
  body: FormValues;
  csrfToken: string;
}) => {
  await axios
    .post(`${environment.PUBLIC_USER_MGMT_URL}/api/users/create/a`, body, {
      timeout: 0,
      headers: {
        'x-surf-token': csrfToken,
      },
      withCredentials: true,
      xsrfCookieName: 'x-surf-token',
      xsrfHeaderName: 'x-surf-token',
    })
    .catch((error: AxiosError<{ message: string; userId: string }>) => {
      if (error.response?.status == 424) {
        return { data: { userId: error.response.data.userId } };
      }

      throw error;
    });

  if (isProduction) {
    mixpanel.track(CTAInteractionTrackingEvents.SIGN_UP_SUCCESS, {
      source: 'dashboard',
    });
  }

  return {
    success: true,
  };
};
